/* eslint-disable react/jsx-indent */
/* eslint-disable react/require-default-props,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,react/destructuring-assignment,react/jsx-one-expression-per-line */
import React, { CSSProperties, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getUniqueId } from '../../../utils/FileUtils'
import { TTenderGalleryList } from '../../../store/admin/settings/mediaManagement/types'
import { useImageSync } from '../../../hooks/useImageSync'
import { Spinner } from '../../../svg/Spinner'

interface TableProps {
  thead: object
  tbody: { id?: number; [x: string]: any }[] | null
  theadChild?: object
  tbodyChild?: Map<number, object[]> | null
  tableCellWidth?: number[]
  no_borders_style?: boolean
  childIndex: number[]
  setChildIndex: (value: ((prev: number[]) => any) | number[]) => void
  styledReserveNotMet?: boolean
  onDeleteAll: (id: number) => void
  items: TTenderGalleryList[]
  tenderId: number
}

export const ImageManagementTable: React.FC<TableProps> = ({
  thead,
  tbody,
  theadChild,
  tbodyChild,
  tableCellWidth,
  no_borders_style,
  childIndex,
  setChildIndex,
  styledReserveNotMet,
  onDeleteAll,
  items,
  tenderId,
}) => {
  const location = useLocation()
  const { resyncItemImages, itemImagesSyncLoading } = useImageSync()

  const parseErrorMessage = (text: string) => {
    return text.includes('message=') ? text.split('message=')[1] : text
  }

  useEffect(() => {
    setChildIndex([])
  }, [location.pathname])

  return (
    <div className='overflow-x-auto relative' style={!no_borders_style ? { minHeight: '120vh' } : {}}>
      <table className={`w-full ${tableCellWidth && 'table-fixed'} border whitespace-nowrap mb-2`}>
        <thead className={`${no_borders_style ? 'bg-white capitalize' : 'bg-gray-50'} text-left`}>
          <tr className='divide-x border-b border-bluegray-200'>
            {Object.entries(thead).map(([key, value], index) => {
              const object = typeof value !== 'string' ? value : null
              let style: CSSProperties = tableCellWidth && tableCellWidth[index] ? { width: tableCellWidth[index] } : {}
              if (!object) style = { ...style, overflow: 'auto' }
              return (
                <th
                  key={`th${key}`}
                  scope='col'
                  style={style}
                  className={`${no_borders_style && 'border-transparent'} whitespace-nowrap`}
                >
                  {value}
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {tbody?.length !== 0 ? (
            tbody?.map(({ id, ...objProps }, index) => {
              const product = items.find((item) => item.item_id === id)
              const error = product ? product.product.google_drive_sync_err_msg : ''
              const childTableBody = tbodyChild ? tbodyChild.get(id || 0) : []

              return (
                <React.Fragment key={`React.Fragment${getUniqueId()}`}>
                  <tr
                    className={`${
                      no_borders_style && index % 2 === 1 && 'bg-white'
                    } divide-x border-b border-bluegray-200 ${
                      styledReserveNotMet && objProps.wining_bid === 'Reserve Not Met' && 'bg-amber-50'
                    }`}
                  >
                    {Object.entries(objProps).map(([key, value]) => {
                      const data = typeof value === 'string' ? value.split('|||') : value
                      return (
                        <td key={`td${key}`} className={`${no_borders_style && 'border-transparent'} relative`}>
                          <div
                            onClick={() =>
                              data.type === 'button' &&
                              setChildIndex((prev) =>
                                childIndex.some((ind) => ind === id) ? prev.filter((ind) => ind !== id) : [...prev, id]
                              )
                            }
                            style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                          >
                            {data[0] || data}
                            <div className='text-sm text-bluegray-400'>{data[1]}</div>
                          </div>
                        </td>
                      )
                    })}
                  </tr>
                  {theadChild && tbodyChild && id && childIndex.some((ind) => ind === id) ? (
                    <tr>
                      <td className='p-0 m-0' colSpan={tableCellWidth?.length || 10000}>
                        <div className='p-4 bg-bluegray-50 shadow-inner w-full'>
                          <div className='bg-gray-200 p-2 flex justify-end'>
                            <div className='flex gap-3'>
                              {error ? (
                                <div className='text-red-600 font-semibold'>{parseErrorMessage(error)}</div>
                              ) : null}

                              <button
                                type='button'
                                onClick={() => resyncItemImages(tenderId, id)}
                                className='delete-bid text-blue-500 font-semibold hover:text-blue-900 underline min-w-[140px] flex justify-center items-center'
                                disabled={itemImagesSyncLoading}
                              >
                                {itemImagesSyncLoading ? <Spinner style={{ color: 'blue' }} /> : 'Resync item images'}
                              </button>
                            </div>

                            <button
                              type='button'
                              onClick={() => onDeleteAll(id)}
                              disabled={tbody?.length === 0}
                              className='delete-bid ml-auto text-orange-500 font-semibold hover:text-orange-900'
                            >
                              Delete all item images
                            </button>
                          </div>

                          <div className='overflow-x-auto'>
                            <table className='w-full border whitespace-nowrap'>
                              <thead className='text-left bg-white'>
                                <tr className='divide-x border-b border-bluegray-200'>
                                  {Object.entries(theadChild).map(([key, value]) => (
                                    <th key={key} scope='col' className='whitespace-nowrap'>
                                      {value}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {childTableBody?.length
                                  ? // @ts-ignore
                                    // eslint-disable-next-line react/destructuring-assignment
                                    childTableBody.map(({ className, ...restObj }) => (
                                      <tr
                                        key={`table-${getUniqueId()}`}
                                        className={`divide-x border-b border-bluegray-200 ${className}`}
                                      >
                                        {Object.entries(restObj).map(([key, value]) => {
                                          const data: any = typeof value === 'string' ? value.split('|||') : value
                                          return (
                                            <td colSpan={key === 'reserve_price' ? 4 : 1} key={`td${key}`}>
                                              {data[0] || data}
                                              <div className='text-sm text-bluegray-400'>{data[1]}</div>
                                            </td>
                                          )
                                        })}
                                      </tr>
                                    ))
                                  : childTableBody && (
                                      <tr>
                                        <td colSpan={10000} className='text-center'>
                                          No available items
                                        </td>
                                      </tr>
                                    )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : null}
                </React.Fragment>
              )
            })
          ) : (
            <tr>
              <td colSpan={tableCellWidth?.length || 10000} height={250} className='text-center'>
                No available items
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}
